import { getBuyerId, getUserType } from 'dibs-cookie-jar';
import { fetchQuery, graphql, Environment } from 'react-relay';
import idx from 'idx';

import { vipCuratedFolderRule_Query as QueryType } from './__generated__/vipCuratedFolderRule_Query.graphql';

const query = graphql`
    query vipCuratedFolderRule_Query($userId: String!) {
        viewer {
            isDisabled: isEnabled(key: "disableCuratedFolders")
            user(userId: $userId) {
                activityFeed(first: 1, elementTypes: [VIP_CURATED_PORTFOLIO_SHARE]) {
                    edges {
                        node {
                            status
                        }
                    }
                }
            }
        }
    }
`;

export async function vipCuratedFolderRule({
    relayEnvironment,
}: {
    relayEnvironment: Environment;
}): Promise<boolean> {
    const userId = getBuyerId(document.cookie);
    const userType = getUserType(document.cookie);
    if (!userId || userType === 'trade') {
        return false;
    }

    const res = await fetchQuery<QueryType>(relayEnvironment, query, { userId });
    const hasUnread = idx(res, o => o.viewer.user.activityFeed.edges[0].node.status) === 'ACTIVE';
    const isDisabled = idx(res, o => o.viewer.isDisabled);
    return hasUnread && !isDisabled;
}
